import React from 'react';
import { useSelector } from 'react-redux';

import { useRoutes } from 'react-router-dom';
import { styled } from '@mui/material/styles';

import FuseDialog from '@fuse/core/FuseDialog';
import FuseMessage from '@fuse/core/FuseMessage';
import FuseSuspense from '@fuse/core/FuseSuspense';
import AppContext from 'app/AppContext';

import FooterLayout1 from './components/FooterLayout1';
import LeftSideLayout1 from './components/LeftSideLayout1';
import NavbarWrapperLayout1 from './components/NavbarWrapperLayout1';
import RightSideLayout1 from './components/RightSideLayout1';
import ToolbarLayout1 from './components/ToolbarLayout1';

interface RootProps {
	mode: 'boxed' | 'container';
	containerWidth: number;
}

const Root = styled('div')<RootProps>(({ theme, containerWidth, mode }) => ({
	...(mode === 'boxed' && {
		clipPath: 'inset(0)',
		maxWidth: `${containerWidth}px`,
		margin: '0 auto',
		boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
	}),
	...(mode === 'container' && {
		'& .container': {
			maxWidth: `${containerWidth}px`,
			width: '100%',
			margin: '0 auto'
		}
	})
}));

function Layout1({ children }: { children: React.ReactNode }) {
	const config = useSelector(({ fuse }: any) => fuse.settings.current.layout.config);
	const appContext = React.useContext(AppContext);
	const { routes } = appContext;

	return (
		<Root id="fuse-layout" className="flex w-full" containerWidth={config.containerWidth} mode={config.mode}>
			{config.leftSidePanel.display && <LeftSideLayout1 />}

			<div className="flex min-w-0 flex-auto">
				{config.navbar.display && config.navbar.position === 'left' && <NavbarWrapperLayout1 />}

				<main id="fuse-main" className="relative z-10 flex min-h-screen min-w-0 flex-auto flex-col">
					{config.toolbar.display && (
						<ToolbarLayout1 className={config.toolbar.style === 'fixed' ? 'sticky top-0' : ''} />
					)}

					{/* <div className="sticky top-0 z-99">
						<SettingsPanel />
					</div> */}

					<div className="relative z-10 flex min-h-0 flex-auto flex-col">
						<FuseDialog />

						<FuseSuspense>{useRoutes(routes)}</FuseSuspense>

						{children}
					</div>

					{config.footer.display && (
						<FooterLayout1 className={config.footer.style === 'fixed' ? 'sticky bottom-0' : ''} />
					)}
				</main>

				{config.navbar.display && config.navbar.position === 'right' && <NavbarWrapperLayout1 />}
			</div>

			{config.rightSidePanel.display && <RightSideLayout1 />}
			<FuseMessage />
		</Root>
	);
}

export default React.memo(Layout1);
